/* global angular, _ */

var ngModule = angular.module('trends');
var $ = jQuery;

ngModule.directive('carouselView', ['AjaxList', 'Api', 'PptService', '$window', '$timeout', 'Input', '$rootScope',
    function (AjaxList, Api, PptService, $window, $timeout, Input, $rootScope) {
        return {
            restrict: 'AC',
            scope: true,
            link: function (scope, element, attrs) {
                var slider = element.find('.carousel-slider');
                var holder = element.find('.slider-holder');
                scope.position = 0;

                slider.bind('keyup', function(e) {
                    /* Retrieve all the item cards as some new ones may have appeared */
                    var itemCards = slider.find('.item-card');
                    itemCards.on('keydown', function(e) {
                        var keyCode = e.keyCode || e.which;
                        var aTags = $(this).find('a');
                        if (attrs.carouselName === 'trend' || attrs.carouselName === 'observation') {
                            aTags.attr('tabindex' , '-1');
                        }
                        if (keyCode === 9) { /* When we tab to a new item, adapt the position */
                            if (e.shiftKey) {
                                var newPosition = itemCards.index(this);
                                if (newPosition >= 0) {
                                    scope.position = newPosition;
                                }
                                else {
                                    scope.position = 0;
                                }
                            }
                            else if(!e.shiftKey) {
                                var newPosition = itemCards.index(this) + 1;
                                if (newPosition < itemCards.length) {
                                    scope.position = itemCards.index(this) + 1;
                                }
                                else {
                                    scope.position = itemCards.length-1;
                                }
                            }
                        }
                        else if(keyCode === 13 && attrs.carouselName !== 'webinar') {
                            var href = aTags[0];
                            if (href) {
                                window.location = href;
                            }
                        }
                    });
                    /* When we leave the slider, we need to focus the right element */
                    var keyCode = e.keyCode || e.which;
                    if (keyCode === 9 && e.target.className.indexOf('item-card') !== -1) {  //  If it's the tab key
                        itemCards.eq(scope.position).focus();
                    }
                });
                scope.setPosition = function (p) {
                    if(scope.canMove(p - scope.position)) {
                        scope.position = p;
                        $rootScope.$broadcast('resetAdd2pptHover');
                    }
                };

                var setPosition = function (p) {
                    scope.position = Math.max(Math.min(p, scope.content.maxItems - 1), 0) | 0;
                };

                var cardWidth = function () {
                    return element.find('.carousel-item').outerWidth(true);
                };
                var updateSlider = function () {
                    // This assumes that all items are uniform width
                    var pos = scope.position * cardWidth() * -1;
                    slider.css('left', pos);
                    $timeout(setSliderHeight);
                };

                var changeCarouselVisibility = function () {
                    if (!attrs.hideEmpty) {
                        return;
                    }

                    var visible = (scope.content.numItems !== 0);
                    if (visible) {
                        element.show();
                    } else {
                        element.hide();
                    }

                    if (attrs.carouselName !== undefined) {
                        scope.$emit('element-visibility', 'carousel-' + attrs.carouselName, visible);
                    }
                };

                var getCurrentCard = function () {
                    return $(slider.children()[scope.position]);
                };

                var setSliderHeight = function () {
                    if ($(window).width() <= 767) {
                        var card = getCurrentCard();
                        if (card) {
                            var h = card.height() + 30; /* 30 as the height of the add to pptbuilder button */
                            slider.css('height', h);
                        }
                    }
                    else {
                        slider.css('height', 'auto');
                    }
                };

                scope.getNumberOfItemsVisible = function () {
                    return Math.max(element.find('.slider-holder').width() / cardWidth(), 1) | 0;
                };
                scope.move = function (dir) {
                    var numVisible = scope.getNumberOfItemsVisible();
                    var boundary = scope.content.numItems - numVisible;
                    var target = scope.position + (dir * numVisible);
                    if (target > boundary && !scope.content.isFullyLoaded()) {
                        var promise = scope.loadMore();
                        if (promise) {
                            promise.then(_.partial(setPosition, target)).then(function () {
                                $timeout(function() {
                                    holder.focus();
                                });
                            });
                            $rootScope.$broadcast('resetAdd2pptHover');
                        }
                    } else {
                        setPosition(target);
                        $rootScope.$broadcast('resetAdd2pptHover');
                        $timeout(function() {
                            holder.focus();
                        });
                    }
                };

                scope.tryMove = function (dir) {
                    if (scope.canMove(dir)) {
                        scope.move(dir);
                    }
                };

                scope.canMove = function (dir) {
                    var numVisible = scope.getNumberOfItemsVisible();
                    var target = scope.position + dir;
                    var inBounds = target >= 0;
                    if (inBounds && scope.content.maxItems !== null) {
                        // If our target is beyond the boundary, then prevent movement
                        // unless we're moving backwards
                        var boundary = scope.content.maxItems - numVisible;
                        if (target > boundary && dir > 0) {
                            inBounds = false;
                        }
                    }
                    return !scope.content.isLoading() && inBounds;
                };

                scope.$watch(function () {
                    // Hacky, but: triggers the callback only once, even if both of these values have changed
                    return (element.find('.carousel-item').length + 1) * (scope.position + 1);
                }, updateSlider);

                scope.$watch('content.numItems', function () {
                    changeCarouselVisibility();
                });

                // Event handlers
                var debounceUpdateSlider = _.debounce(updateSlider, 150);
                scope.$on('dataSourceChanged', _.partial(setPosition, 0));
                scope.$on('elementLoaded',
                    function(event) {
                        event.preventDefault();
                        debounceUpdateSlider();
                    }
                );
                $($window).on('resize', debounceUpdateSlider);

                Input.addArrowMovementHandler(holder, function (dx) {
                    var changed = dx !== 0;
                    if (changed) {
                        scope.$apply(function () {
                            scope.move(dx);
                        });
                    }
                    return changed;
                });
            }
        };
    }]);
